import { Box, Button, Link, Text } from "@chakra-ui/react";
import React from "react";
import HeadingCompo from "./HeadingCompo";
import GlassyBox from "../customComponents/GlassyBox";

const About = () => {
  const openGoggleDrive = () => {
    setTimeout(() => {
      window.open(
        "https://drive.google.com/file/d/14eP5hBhem8akKlTucxmChlMECWadIu39/view?usp=sharing"
      );
    }, 1500);
  };

  return (
    <Box id="About">
      <Box mb="30px">
        <HeadingCompo>About</HeadingCompo>
      </Box>
      <GlassyBox>
        <Box w="70%" m="auto" textAlign="center">
          <Text color="#fff" fontSize={{ lg: "20px", md: "17px", sm: "15px" }}>
            Aspiring Full Stack web development professional seeking to learn
            new technologies. Technically proficient, with over 1200+ hours of
            hands-on coding experience. A problem solver solved over 500+ data
            structure and algorithm problems.
          </Text>
          <Link
            _hover={{ textDecoration: "none" }}
            href="fw21_0183-Faizal-Siddiqui-Resume.pdf"
            download={true}
          >
            <Button onClick={openGoggleDrive} mt="20px" colorScheme="teal">
              Resume
            </Button>
          </Link>
        </Box>
      </GlassyBox>
    </Box>
  );
};

export default About;
